import React, {
  useState,
  useEffect,
  useCallback,
  useContext,
  useMemo,
} from "react";

import isEmpty from "lodash.isempty";
import { observer } from "mobx-react";

import ComponentContext from "../../../contexts/ComponentContext";
import { useStores } from "../../../contexts/StoreContext";
import apiInstance from "../../../services/api";
import normalizeFilters from "../../helpers/normalizeFilters";
import normalizeFiltersByRelatedTo from "../../helpers/normalizeFiltersByRelatedTo";
import Markdown from "../../styles/Markdown";
import Loader from "../Loader/Loader";
import JobList from "./JobList";

function LatestJobs() {
  const {
    numberOfJobs,
    title,
    predefinedFilters,
    relatedTo = [],
    tenantIds,
  } = useContext(ComponentContext);
  const { vacancyStore } = useStores();
  const [isLoading, setIsLoading] = useState(true);
  const [jobData, setJobData] = useState([]);

  const showRelatedToJobs = !isEmpty(relatedTo);

  const { selectedVacancy } = vacancyStore;

  const normalizedFilters = useMemo(
    () => normalizeFiltersByRelatedTo(selectedVacancy, relatedTo),
    [selectedVacancy]
  );

  const normalizedPredefinedFilters = useMemo(
    () => normalizeFilters(predefinedFilters),
    [predefinedFilters]
  );

  const fetchJobs = useCallback(() => {
    apiInstance
      .getVacancies(
        { ...normalizedFilters, ...normalizedPredefinedFilters },
        {
          fields: [
            "id",
            "jobTitle",
            "location",
            "remuneration",
            "description",
            "company",
            "validFrom",
            "category",
            "hoursType",
            "applicationUrl",
          ],
          limit: numberOfJobs,
        },
        tenantIds,
        { ...normalizedFilters, ...normalizedPredefinedFilters }
      )
      .then((response) => {
        const filteredResponse = response.data.results.filter(
          (vacancyItem) =>
            !showRelatedToJobs || vacancyItem.id !== selectedVacancy?.id
        );
        setIsLoading(false);
        setJobData(filteredResponse);
      });
  }, [normalizedFilters]);

  useEffect(() => {
    if (isEmpty(normalizedFilters) || showRelatedToJobs) {
      fetchJobs();
    }
  }, [normalizedFilters]);

  if (!isLoading && !jobData.length) return null;

  return (
    <>
      <Markdown className="mb-4">{title}</Markdown>
      {isLoading && <Loader />}
      {!isLoading && <JobList jobs={jobData} />}
    </>
  );
}

export default observer(LatestJobs);
